module.exports = __webpack_public_path__ + "assets/images/pages/unleash/icon-unleash-2.png?801c1f80";